import { setUrlSearchParam } from '../../../../_common/client/set-url-search-param';
import { enableOrDisablePaginationButtons } from './enable-or-disable-pagination-buttons';
import { triggerReloadForNewPage } from './trigger-reload-for-new-page';
import { updateCurrentPageInHtml } from './update-current-page-in-html';
import { scrollPageToReviews } from '../scroll-page-to-reviews';
import { sendTrackingEvent } from './send-tracking-event';

export enum PaginationType {
    FIRST = 'FIRST',
    PREVIOUS = 'PREVIOUS',
    NEXT = 'NEXT',
    LAST = 'LAST',
}

export async function onPaginationButtonClick(newPageNumber: number, listWrapperRootElement: HTMLElement, paginationType: PaginationType) {
    await triggerReloadForNewPage(newPageNumber, listWrapperRootElement);
    setUrlSearchParam('page', newPageNumber.toString());
    updateCurrentPageInHtml(newPageNumber, listWrapperRootElement);
    enableOrDisablePaginationButtons(newPageNumber, listWrapperRootElement);
    scrollPageToReviews(listWrapperRootElement);
    sendTrackingEvent(paginationType, newPageNumber);
}
